module.exports = __webpack_public_path__ + "img/ch08_11_小满记笔记.86798394.jpg";